export default function PHP_microtime() {
  return (
    <div>
      <h1>PHP_microtime</h1>
    </div>
  );
}
